export default "__VITE_ASSET__Czp3bZfj__"